export default __webpack_public_path__ + "static/media/preloader.6fb12609.svg";